"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var createFeature_1 = require("../createFeature");
exports.setDisabledAction = (_a = createFeature_1.createInputFeature('disabled'), _a.actionCreator), exports.disabledSelector = _a.selectorCreator, exports.DisabledFeature = _a.featureReducer;
//# sourceMappingURL=disabled.js.map